module.exports = "/_next/static/images/address-bg2-3d5ade49b8de7777d50881e4f1bae9e8.jpg";